import type { Instance } from 'mobx-state-tree'
import { PaginationInfoModelBase } from './PaginationInfoModel.base'

/* The TypeScript type of an instance of PaginationInfoModel */
export interface PaginationInfoModelType extends Instance<typeof PaginationInfoModel.Type> {}

/* A graphql query fragment builders for PaginationInfoModel */
export {
  PaginationInfoModelSelector,
  paginationInfoModelPrimitives,
  selectFromPaginationInfo
} from './PaginationInfoModel.base'

/**
 * PaginationInfoModel
 */
export const PaginationInfoModel = PaginationInfoModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
